function getToken() {
  const user = JSON.parse(localStorage.getItem("currentUser"));
  const token = user && user.jwtAccessToken;
  return token;
}

async function getDashboardData(plantName) {
  const baseUrl = process.env.REACT_APP_GET_DASHBOARD_DATA;

  if (!baseUrl) {
    console.error("REACT_APP_GET_DASHBOARD_DATA is not defined in the .env file");
    throw new Error("API base URL is missing");
  }

  const params = new URLSearchParams({ plantName }).toString();
  const url = `${baseUrl}?${params}`;

  const sessionId = localStorage.getItem("JSESSIONID") || "";

  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Cookie: `JSESSIONID=${sessionId}`, 
    },
    credentials: "include", 
  };

  try {
    const response = await fetch(url, requestOptions);

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unexpected error"} (Status: ${response.status})`);
    }

    return await response.json(); 
  } catch (error) {
    console.error("Error fetching dashboard data", error);

    throw {
      status: error.status || 500,
      error: error.message || "Unexpected error occurred",
    };
  }
}

async function getSectionsDetails(plantName) {
  const baseUrl = process.env.REACT_APP_GET_SECTION_DATA;

  if (!baseUrl) {
    console.error("REACT_APP_GET_SECTION_DATA is not defined in the .env file");
    throw new Error("API base URL is missing");
  }

  const url = `${baseUrl}?plant_name=${encodeURIComponent(plantName)}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7',
      },
    });

    if (!response.ok) {
      const errorData = await response.text();
      throw new Error(`Error: ${errorData || 'Unexpected error'} (Status: ${response.status})`);
    }

    const data = await response.json(); 
    console.log('API Response:', data);
    return data;
  } catch (error) {
    console.error('Error fetching section details:', error);

    throw {
      status: error.status || 500,
      error: error.message || "Unexpected error occurred",
    };
  }
}

async function getProductDetails(sectionUuid) {
  const baseUrl = process.env.REACT_APP_GET_PRODUCT_LIST;

  if (!baseUrl) {
    throw new Error("API base URL is missing");
  }

  const url = `${baseUrl}?section_uuid=${encodeURIComponent(sectionUuid)}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Accept-Language': 'en-GB,en-US;q=0.9,en;q=0.8',
      },
    });

    const data = await response.json();
    console.log('API Response:', data);
    return data;
  } catch (error) {
    console.error('Error fetching product details:', error);
    throw {
      status: error.status || 500,
      error: error.message || "Unexpected error occurred",
    };
  }
}


async function getDeviceEvents({ deviceUuid, eventType, deviceName, startTime, endTime, page = 0, size = 150000 }) {
  const baseUrl = process.env.REACT_APP_GET_DEVICE_DETAILS; 

  if (!baseUrl) {
    console.error("REACT_APP_GET_DEVICE_EVENTS is not defined in the .env file");
    throw new Error("API base URL is missing");
  }

  const params = new URLSearchParams({
    device_uuid: deviceUuid,
    event_type: eventType,
    device_name: deviceName,
    startTime: startTime,
    endTime: endTime,
    page: page,
    size: size,
  })

  const url = `${baseUrl}?${params}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json, text/plain, */*',
      },
    });

    if (!response.ok) {
      const errorData = await response.text();
      console.error('Error Response:', errorData);
      throw new Error(`Error: ${errorData || 'Unexpected error'} (Status: ${response.status})`);
    }

    const data = await response.json();
    return data;

  } catch (error) {
    console.error('Error fetching device events:', error);
    throw {
      status: error.status || 500,
      error: error.message || "Unexpected error occurred",
    };
  }
}

export async function getAllAlerts({ productUuid, productId, startTime, endTime, page=0, size =100000}) {
  try {
    const baseUrl = process.env.REACT_APP_GET_ALERTS_INFO;
    
    const params = new URLSearchParams();
    params.append('productUuid', productUuid);
    params.append('productId', productId); 
    params.append('startTime', startTime); 
    params.append('endTime', endTime);
    params.append('page', page);
    params.append('size', size);

    const url = `${baseUrl}?${params.toString()}`;
    console.log("API Request URL:", url);

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`API Error: ${response.status} - ${errorText}`);
    }

    const data = await response.json();
    console.log("API Response Data:", data); 
    return data; 
    
  } catch (error) {
    console.error("Fetch Error:", error);
    throw error; 
  }
}
async function getDashboardAlertsInfo(plantName) {
  const baseUrl = process.env.REACT_APP_GET_DASHBOARD_ALERTS_INFO;

  if (!baseUrl) {
    console.error("REACT_APP_GET_DASHBOARD_ALERTS_INFO is not defined in .env");
    throw new Error("API base URL is missing");
  }

  const url = `${baseUrl}?plantName=${encodeURIComponent(plantName)}`;

  try {
   const response = await fetch(url, {
  method: 'GET',
  credentials: 'include', 
  headers: {
    'Accept': '*/*',
    'Accept-Language': 'en-GB,en-US;q=0.9,en;q=0.8',
    'Sec-Fetch-Dest': 'empty',
    'Sec-Fetch-Mode': 'cors',
    'Sec-Fetch-Site': 'same-origin',
    'Referer': 'http://localhost/plant-monitoring/dashboard',
    'User-Agent': 'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/126.0.0.0 Safari/537.36',
  },
});

    if (!response.ok) {
      if (response.status === 401) {
        window.location.href = '/login'; 
      }
      const errorData = await response.text();
      throw new Error(`Error: ${errorData || 'Unexpected error'} (Status: ${response.status})`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching alerts:', error);
    throw {
      status: error.status || 500,
      error: error.message || "Unexpected error occurred",
    };
  }
}

async function getGraphData(params) {
  const baseUrl = process.env.REACT_APP_GET_GRAPH_LINE_DATA;

  if (!baseUrl) {
    throw new Error("API base URL is missing");
  }

  const cleanedParams = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      cleanedParams[key] = value;
    }
  });

  const urlParams = new URLSearchParams();
  Object.entries(cleanedParams).forEach(([key, value]) => {
    urlParams.append(key, value);
  });

  const url = `${baseUrl}?${urlParams.toString()}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'include'
    });

    if (!response.ok) {
      let errorData;
      try {
        errorData = await response.json(); 
      } catch (e) {
        errorData = { message: `API Error: ${response.status}` };
      }
      
      throw new Error(errorData.message || 
                     `${response.status} ${response.statusText}` || 
                     'API request failed');
    }

    const data = await response.json();
    
    
    return {
      status: "success",
      data: data
    };
  } catch (error) {
    console.error('Error fetching graph data:', {
      error: error.message,
      url: url,
      params: params
    });
    
    return {
      status: "error",
      error: error.message || "Unexpected error occurred",
      statusCode: error.status || 500
    };
  }
}

 async function exchangeCodeForToken(code, state) {
  console.log('Exchanging code for token...');

  
  if (!code) {
    throw new Error('Authorization code not found in URL');
  }

  const requiredEnvVars = [
    'REACT_APP_CLIENT_ID',
    'REACT_APP_CLIENT_SECRET',
    'REACT_APP_REDIRECT_URI',
    'REACT_APP_TOKEN_URL'
  ];

  const missingVars = requiredEnvVars.filter(varName => !process.env[varName]);
  if (missingVars.length > 0) {
    throw new Error(`Missing environment variables: ${missingVars.join(', ')}`);
  }

  const tokenRequestBody = new URLSearchParams({
    grant_type: 'authorization_code',
    code,
    redirect_uri: process.env.REACT_APP_REDIRECT_URI
  });

  const authHeader = 'Basic ' + btoa(
    `${process.env.REACT_APP_CLIENT_ID}:${process.env.REACT_APP_CLIENT_SECRET}`
  );

  const url = process.env.REACT_APP_TOKEN_URL;
  console.log("Token Exchange URL:", url);

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': authHeader
      },
      body: tokenRequestBody.toString(),
    });

    if (!response.ok) {
      let errorData;
      try {
        errorData = await response.json(); 
      } catch (e) {
        errorData = { message: `API Error: ${response.status}` };
      }

      throw new Error(errorData.message || `${response.status} ${response.statusText}`);
    }

    const tokenData = await response.json();
    console.log('Token response received:', tokenData);

    if (!tokenData.access_token) {
      throw new Error('Access token missing in response');
    }

    return tokenData;
  } catch (error) {
    console.error('Token exchange error:', {
      error: error.message,
      url: url
    });

    throw new Error(error.message || "Token exchange failed");
  }
}

async function getFlowmeterLiveEvent({
  deviceType = "flowmeter",
  productUUID,
  deviceUUID,
  deviceName = "FLOWMETER",
  time 
}) {  

  if (!deviceUUID) {
    const error = new Error("deviceUUID is required");
    console.error("Missing deviceUUID:", error);
    throw error;
  }

  if (!productUUID) {
    const error = new Error("productUUID is required");
    console.error("Missing productUUID:", error);
    throw error;
  }

  const baseUrl = process.env.REACT_APP_GET_DASHBOARD_FLOWMETER_DATA;
  
  if (!baseUrl) {
    const error = new Error("API base URL not configured");
    console.error("Missing REACT_APP_GET_DASHBOARD_FLOWMETER_DATA:", error);
    throw error;
  }

  let formattedTime = time;
  if (!formattedTime) {
    const now = new Date();
    const year = now.getUTCFullYear();
    const month = String(now.getUTCMonth() + 1).padStart(2, '0');
    const day = String(now.getUTCDate()).padStart(2, '0');
    const hours = String(now.getUTCHours()).padStart(2, '0');
    const minutes = String(now.getUTCMinutes()).padStart(2, '0');
    const seconds = String(now.getUTCSeconds()).padStart(2, '0');
    formattedTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  const queryParams = new URLSearchParams({
    deviceType: deviceType,
    productUUID: productUUID,
    deviceUUID: deviceUUID,
    deviceName: deviceName,
    time: formattedTime
  });

  const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  const url = `${cleanBaseUrl}?${queryParams}`;

  console.log('Final Request URL:', url);

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Accept": "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      credentials: "include"
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("API Error:", {
        status: response.status,
        statusText: response.statusText,
        error: errorText
      });
      throw new Error(`HTTP ${response.status}: ${errorText}`);
    }

    const data = await response.json();
    console.log('API Response:', data);
    return data;

  } catch (error) {
    console.error("Flowmeter API Error:", {
      message: error.message,
      url: url,
      parameters: { deviceUUID, productUUID, deviceName, time }
    });
    throw error;
  }
}

export async function getEnergyMeterLiveData({
  deviceType,
  productUUID,
  deviceUUID,
  deviceName,
  time
}) {
  try {
    const baseUrl =
      process.env.REACT_APP_GET_DASHBOARD_ENERGYMETER_DATA;

    if (!baseUrl) {
      throw new Error(
        "Missing env variable: REACT_APP_GET_DASHBOARD_ENERGYMETER_DATA"
      );
    }

    const queryParams = new URLSearchParams({
      deviceType,
      productUUID,
      deviceUUID,
      deviceName,
      time
    }).toString();

    const url = `${baseUrl}?${queryParams}`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      credentials: "include" 
    });

    if (!response.ok) {
      throw new Error(`API failed with status ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching energy meter live data", error);
    throw error;
  }
}

export const provisioningService = {
  exchangeCodeForToken,
  getDashboardData,
  getSectionsDetails,
  getProductDetails,
  getDeviceEvents,
  getAllAlerts,
  getDashboardAlertsInfo,
  getGraphData,
  getFlowmeterLiveEvent,
  getEnergyMeterLiveData
};
